import { ToolMenu, ToolMenuContent } from '@aon/aon-tws-common-ui';
import * as React from 'react';
import { connect } from 'react-redux';
import { IQueryOptions } from '../../models/GroupAccessOwners/ServiceInterfaces';
import { IApplicationState } from '../../store';
import { FetchStateForView, IGroupAccessOwnerViewState } from '../../store/GroupAccessOwners/ViewStore';
import { ActionCreators, IProfileViewScope } from '../../store/GroupAccessOwnersForProfileActions';
import { BaseOwnerListView } from './GroupAccessOwners/BaseView';

export interface IGroupAccessOwnersForProfileViewProps extends IGroupAccessOwnerViewState {
	hrisId: string;
	profileId: string;
	hierarchyIds: string[];

	constructColumns: (scope: IProfileViewScope, forView: string) => void;
	constructFilterables: (scope: IProfileViewScope, forView: string) => void;
	queryForOwners: (query: IQueryOptions, scope: IProfileViewScope, forView: string) => void;

	whenDataIsNotAvailable?: Partial<{
		render: () => JSX.Element;
		handle: () => void;
	}>;
}

export const GetViewIdentifier = (profileId: string) => `Profile_${profileId}`;

export class GroupAccessOwnersForHrisProfileView extends React.Component<IGroupAccessOwnersForProfileViewProps> {
	private get Scope(): IProfileViewScope {
		const { hrisId, profileId, hierarchyIds } = this.props;

		return {
			forHris: hrisId,
			forProfile: profileId,
			hierarchyIds,
		};
	}

	public render() {
		const { profileId } = this.props;

		return (
			<BaseOwnerListView
				{...this.props}
				scope={this.Scope}
				viewIdentifier={GetViewIdentifier(profileId)}
				renderList={(components) => {
					const { columnSelector, filterSelector, pagination, searchBar, tableView } = components;

					return (
						<>
							{pagination}
							<ToolMenu>
								<ToolMenuContent type={'right'}>{searchBar}</ToolMenuContent>
								<ToolMenuContent type={'left'}>
									{columnSelector}
									{filterSelector}
								</ToolMenuContent>
							</ToolMenu>
							{tableView}
						</>
					);
				}}
			/>
		);
	}
}

export const ConnectedGroupAccessOwnersForProfile = connect((state: IApplicationState, ownProps: { hrisId: string; profileId: string }) => {
	return {
		...FetchStateForView(state, GetViewIdentifier(ownProps.profileId)),
		hrisId: ownProps.hrisId,
		profileId: ownProps.profileId,
	};
}, ActionCreators)(GroupAccessOwnersForHrisProfileView);
